import SmallInfoNoticeBlock from 'atoms/SmallInfoNoticeBlock';

const HeadersInfo: React.FC = () => (
  <div className="mt-8 ml-4">
    <SmallInfoNoticeBlock>
      All these header values are mandatory. They must exist in every request.
    </SmallInfoNoticeBlock>
  </div>
);

export default HeadersInfo;
